import React, { useEffect, useState, useMemo } from "react";
import FlexComponentMobile from "../../Trade/Listing/HomepageRevamp4.0/FlexComponentMobile/FlexComponentMobile";
import HeadLines from "../../CommonComponents/HeadLines";
import { isMobile } from "../../helperFunc";
import style from "./style.module.css";
import Button from "../../CommonComponents/Button";
import { downArrow, HomeImage, moneyBag, TreeIcon } from "../../icon_assets";
import TwoLineWidget from "../../CommonComponents/TwoLineWidget/TwoLineWidget";
import CommodityPieChart from "./CommodityPieChart";
import { useHistory } from "react-router";
import CustomSelect from "../../CommonComponents/CustomReactSelect/CustomSelect";
import { aryaProStockCommodities } from "../../../../../_services/Arya2.0/Storage/api";
import useIsUserLoggedIn from "../../CustomHooks/useIsUserLoggedIn";
import {
  getAllCommodityList,
  getAllLocation,
} from "../../../../../_services/Arya2.0/Warehouse";
import { customToastr } from "../../CustomToastr";
import Loader from "../../CommonComponents/Loader/Loader";
import { useTranslation } from "react-i18next";
import useDebounce from "../../CustomHooks/useDebounce";
import { maxTwoDigitFractionHandler } from "../../CommonFunctions/Function";

// Memoized color generation function to avoid unnecessary recalculations

const colors = [
  "#904B4B",
  "#6053A1",
  "#564107",
  "#29746B",
  "#8B344E",
  "#EEC044",
  "#0DC7B1",
  "#494949",
  "#E59E9E",
  "#AA6A20",
  "#AFC99B",
  "#D8581C",
  "#33A2F2",
  "#475833",
  "#82D2DD",
];

let availableColors = [...colors];

const getCommodityColor = () => {
  if (availableColors.length === 0) {
    return colors[Math.floor(Math.random() * colors.length)];
  }
  return availableColors.shift();
};

const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const MyCommodities = () => {
  const history = useHistory();
  const { t: translation } = useTranslation();
  const [commodityData, setCommodityData] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userLoggedIn] = useIsUserLoggedIn();
  const [locationInputValue, setLocationInputValue] = useState("");

  const getCommodityData = async () => {
    try {
      setIsLoading(true);
      const res = await aryaProStockCommodities();
      if (res?.status_code === 200) {
        const formattedData = res?.data?.commodity_wise_stock?.map((item) => {
          const color = getCommodityColor();

          return {
            commodityId: item.commodity_id < 0 ? 0 : item.commodity_id,
            commodityName: `${translation(item.commodity_name)}` || "",
            quantity:
              item.total_stock < 0
                ? 0
                : parseFloat(item.total_stock.toFixed(1)),
            commodityColor: color,
          };
        });

        setCommodityData(formattedData);

        // Reset the colors array for future calls
        availableColors = [...colors];
      }
    } catch (error) {
      customToastr({
        text: error.message,
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userLoggedIn) {
      getCommodityData();
    }
  }, [userLoggedIn]);

  const getCommodityList = async () => {
    try {
      const res = await getAllCommodityList();
      if (res?.status_code === 200) {
        res?.data?.map((item) => {
          setCommodityList((prevList) => [
            ...prevList,
            { value: item.id, label: item.name },
          ]);
        });
      }
    } catch (error) {
      customToastr({
        text: error.message,
        type: "error",
      });
    }
  };

  // Location Filter Listing API
  const getLocationList = async () => {
    try {
      const dataObj = {
        query: locationInputValue,
      };
      const res = await getAllLocation(dataObj);
      if (
        res?.status_code === 200 &&
        res?.data &&
        res?.data?.DISTRICT?.length > 0
      ) {
        const updatedLocationList = res?.data?.DISTRICT?.map((item) => ({
          value: item.geoLocationId,
          label: `${toTitleCase(item?.city)}`,
        }));

        setLocationList(updatedLocationList);
      }
    } catch (error) {
      customToastr({
        text: error.message,
        type: "error",
      });
    }
  };

  const handleInputChange = (value) => {
    setLocationInputValue(value);
  };

  // useEffect(() => {
  //   if (locationInputValue?.length >= 3 && !commodityData?.length > 0) {
  //     getLocationList();
  //   }
  // }, [locationInputValue]);

  useDebounce(
    () => {
      if (locationInputValue?.length >= 3) getLocationList();
    },
    500,
    [locationInputValue]
  );

  const totalItems = commodityData?.length > 0 ? commodityData?.length : 0;

  const [cityFilterValue, setCityFilterValue] = useState(null);
  const [commodityFilterValue, setCommodityFilterValue] = useState(null);

  const handleCityChange = (selectedOption) => {
    setCityFilterValue(selectedOption);
  };

  const handleCommodityChange = (selectedOption) => {
    setCommodityFilterValue(selectedOption);
  };

  const handleSearchWarehouse = () => {
    const locationId = cityFilterValue?.value;
    const commodityId = commodityFilterValue?.value;

    const queryParams = new URLSearchParams();
    if (locationId) queryParams.append("locationId", locationId);
    if (commodityId) queryParams.append("commodityId", commodityId);

    history.push({
      pathname: "/my-storage/warehouses",
      search: `?${queryParams.toString()}`,
      state: {
        locationName: cityFilterValue?.label,
      },
    });
  };

  const reactSelectStyles = {
    input: (base) => ({ ...base, fontSize: isMobile ? 14 : 16 }),
    placeholder: (base) => ({
      ...base,
      fontSize: isMobile ? 14 : 16,
      color: "#B8BDBD",
    }),
    singleValue: (base) => ({ ...base, fontSize: isMobile ? 14 : 16 }),
    control: (base) => {
      return {
        ...base,
        height: 40,
        backgroundColor: "#FFFFFF",
        outline: "none",
        boxShadow: "none",
        border: `1px solid #E1E3E3`,
        ":hover": {
          border: `1px solid #E1E3E3`,
        },
      };
    },
  };

  const handleViewDetail = () => {
    history.push("/my-storage/commodities");
  };

  const handleApply = () => {
    history.push("/loan-against-commodity-Page-Form");
  };

  // Memoize commodity data to avoid unnecessary re-renders
  // const memoizedCommodityData = useMemo(() => commodityData, [commodityData]);

  return (
    <>
      <Loader isLoading={isLoading} />

      <div
        className={
          isMobile ? `${style.marginBottom30}` : `margin-top30 margin-bottom10`
        }
      >
        {isMobile ? (
          <FlexComponentMobile
            leftTitle="My Commodities"
            rightNumber={totalItems}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-space-between">
            <div className="d-flex align-items-center gap8">
              <HeadLines
                text="My Commodities"
                className={`font-weight500 font-size18 line-height21 colorDark5`}
              />
              <HeadLines
                text={totalItems}
                className={`font-weight500 font-size18 line-height21 backAccent3 textColorWhite boxRadius4 textCenter ${style.padding4_5} ${style["w30"]}`}
              />
            </div>
            <div className="d-flex align-items-center gap20">
              {commodityData && commodityData?.length > 0 ? (
                <Button
                  title="View Details"
                  onClick={handleViewDetail}
                  className={`${
                    isMobile
                      ? "font-size14 line-height16 colorAccent3"
                      : "font-size16 line-height19 colorAccent3"
                  } font-weight500 cursorPointer ${
                    style.transparentbackground
                  }`}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        )}

        {commodityData && commodityData?.length > 0 ? (
          <>
            <div
              className={`d-flex align-items-center ${
                isMobile
                  ? `${style["mobCommodityDiv2"]}`
                  : `${style["divBorder"]} ${style["boxtopRadius8"]} ${style["justifySpaceEvenly"]} margin-top20`
              }`}
            >
              <div>
                <CommodityPieChart commodityData={commodityData} />
              </div>
              {!isMobile ? (
                <div
                  className={`${style.scrollableDiv} ${
                    commodityData?.length < 5 && style["overflowY"]
                  } ${style.flexDiv} padding-right20`}
                >
                  {commodityData?.map((commodity) => (
                    <div
                      key={commodity?.commodityId}
                      className="d-flex align-items-center justify-content-space-between"
                    >
                      <div className="d-flex align-items-center gap10">
                        <div
                          className={style.boxRadius5}
                          style={{
                            height: "15px",
                            width: "15px",
                            backgroundColor: commodity?.commodityColor,
                          }}
                        />
                        <span
                          className={`font-weight400 font-size14 line-height16 ${style.blackColor}`}
                        >
                          <HeadLines text={commodity?.commodityName} />
                        </span>
                      </div>
                      <span
                        className={`font-weight600 font-size14 line-height16 ${style.blackColor}`}
                      >
                        {maxTwoDigitFractionHandler(commodity?.quantity)} MT
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className={`${style["mobileCommList"]} ${style["mobBoxPadding"]} margin-bottom20 width-100`}
                >
                  <div className={style.gridContainer}>
                    {commodityData?.map((commodity) => (
                      <div key={commodity?.id} className={style.gridItem}>
                        <div
                          className={style.boxRadius5}
                          style={{
                            height: "15px",
                            width: "15px",
                            backgroundColor: commodity?.commodityColor,
                          }}
                        />
                        <TwoLineWidget
                          title={commodity?.commodityName}
                          subtitle={`${commodity?.quantity} MT`}
                          subtitleClassName={style["mobileSubTitle"]}
                          titleClassName={style["mobileTitle"]}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Loan Section */}
            <div
              className={`${style.greenBack} ${
                isMobile
                  ? `${style.borderRadius12} padding-left16 padding-right16 padding-top16 padding-bottom16 gap10`
                  : `${style.buttonRadius} padding-top10 padding-bottom10`
              } d-flex align-items-center justify-content-center`}
            >
              <img
                src={moneyBag}
                className={isMobile ? `` : `${style.marginright7}`}
                style={{
                  width: isMobile && "25px",
                  height: isMobile && "25px",
                }}
              />
              <HeadLines
                className={`${
                  isMobile
                    ? `font-weight400 font-size14 line-height16`
                    : `font-weight500 font-size20 line-height24 ${style.marginright17}`
                } textColorWhite`}
                text="Get instant loan against commodity from Aryadhan"
              />
              <Button
                title={isMobile ? `Apply Loan` : `Apply Now`}
                onClick={handleApply}
                className={`${
                  isMobile
                    ? `font-size12 line-height14 boxRadius4 padding-top8 padding-bottom8 ${style.width30}`
                    : `font-size16 line-height19 boxRadius6 ${style.paddingTopBottom9}`
                }  textColorWhite font-weight500 cursorPointer backAccent3`}
              />
            </div>
          </>
        ) : (
          <div
            className={`${
              isMobile ? style["mobCommodityDiv"] : style["noCommodityDiv"]
            } margin-top20`}
          >
            <div className={`positionRelative`}>
              <img
                src={HomeImage}
                className={
                  isMobile
                    ? `${style["mobHomepageClass"]}`
                    : `${style["hompageClass"]}`
                }
              />
              <div
                className={`${style["positionAbsolute"]} ${
                  isMobile ? style["mobpaddingImage"] : style["paddingImage"]
                } d-flex gap20 ${isMobile ? `flex-d-col` : ``} `}
              >
                <div className={`width-100 ${isMobile ? `` : `margin-top16`}`}>
                  <HeadLines
                    text="India's largest Warehouse Search Engine for Agri commodities"
                    className={`font-weight500 textColorWhite ${
                      isMobile
                        ? `font-size14 line-height16`
                        : `font-size20 line-height23`
                    }`}
                  />
                  <div
                    className={`d-flex align-items-center gap4 ${
                      isMobile
                        ? `padding-bottom16 margin-top16`
                        : `padding-bottom10 margin-top24`
                    }`}
                  >
                    <img src={TreeIcon} />
                    <HeadLines
                      text="Book warehouse, Anytime, Anywhere!"
                      className={`font-weight400 textColorWhite ${
                        isMobile
                          ? `font-size12 line-height14`
                          : `font-size16 line-height19`
                      }`}
                    />
                  </div>
                  <div
                    className={`d-flex align-items-center gap4 ${
                      isMobile ? `padding-bottom16` : `padding-bottom10`
                    }`}
                  >
                    <img src={TreeIcon} />
                    <HeadLines
                      text="Find a warehouse closest to you"
                      className={`font-weight400 textColorWhite ${
                        isMobile
                          ? `font-size12 line-height14`
                          : `font-size16 line-height19`
                      }`}
                    />
                  </div>
                  <div className="d-flex align-items-center gap4">
                    <img src={TreeIcon} />
                    <HeadLines
                      text="Compare and choose from over 50 parameters"
                      className={`font-weight400 textColorWhite ${
                        isMobile
                          ? `font-size12 line-height14`
                          : `font-size16 line-height19`
                      }`}
                    />
                  </div>
                </div>

                {!isMobile && <div className={style["lineCss"]} />}

                <div
                  className={`width-100 ${
                    isMobile ? `` : `d-flex flex-d-col justify-content-center`
                  }`}
                >
                  <div className={``}>
                    <div className="d-flex align-items-center gap2">
                      <HeadLines
                        text="Preferred District"
                        className={`font-weight500 font-size16 line-height19 textColorWhite`}
                      />
                    </div>
                    <CustomSelect
                      selectArrow={downArrow}
                      placeholder={translation("Search by district name.")}
                      outerStyles={reactSelectStyles}
                      onChange={handleCityChange}
                      options={locationList}
                      noOptionsMessage={({ inputValue }) => {
                        return inputValue?.length > 3
                          ? "No cities found"
                          : null;
                      }}
                      value={cityFilterValue}
                      inputValue={locationInputValue}
                      onInputChange={handleInputChange}
                    />
                  </div>

                  {/* <div className={`${style["marginBottom30"]}`}>
                    <div className="d-flex align-items-center gap2">
                      <HeadLines
                        text="Commodity"
                        className={`font-weight500 font-size16 line-height19 textColorWhite`}
                      />
                    </div>
                    <CustomSelect
                      placeholder={translation("Please Select")}
                      selectArrow={downArrow}
                      outerStyles={reactSelectStyles}
                      onChange={handleCommodityChange}
                      options={commodityList}
                      value={commodityFilterValue}
                    />
                  </div> */}

                  <Button
                    title={"Search Warehouse"}
                    onClick={handleSearchWarehouse}
                    className={
                      " d-flex mlr-auto margin-top16 padding-left24 padding-right24 textColorWhite boxRadius6 padding105 backAccent3 font-weight500 font-size16 line-height19"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MyCommodities;
